import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./Authentication/AuthSlice";
import SignupSlice from "./Authentication/SignupSlice";
import BookingHistorySlice from "./BookingHistory/BookingHistorySlice";
import CommonSlice from "./Common/CommonSlice";
import QueriesSlice from "./Queries/QueriesSlice";
import SearchRatesSlice from "./SearchRates/SearchRatesSlice";
import KycSlice from "./User/KycSlice";
import ProfileSlice from "./User/ProfileSlice";
import OfflinePaymentSlice from "./OfflinePayement/OfflinePaymentSlice";
import CreditLimitSlice from "./User/CreditLimitSlice";
import sharedStateReducer from "./Newslices/sharedStateSlice";
import  set_selectedOption  from "./Newslices/classdescription";
import  setlclpackagedata  from "./Newslices/Lclpackdata";
import dataReducer from './Authentication/RolesSlice';
// import { setRole } from "./Authentication/RolesSlice";
import rolesReducer from './Authentication/RolesSlice';
import loginAirlineSlice from './LoginAirlineAuth/AuthSlice'
// import { set_error } from "./Newslices/errordropdown";
import organizationReducer from './Organization/organizationSlice';
import customeradmin from './Customeradmin/cutomeradminslice'
import markupSlice from "./Markup/markupSlice";
import Vehicletypeslice from "./vehicletype/Vehicletypeslice";
import airportReducer from "./BookingIntermediaterypage/airlineairportslice";
import contactSlice from "./CutomerContact/contactSlice"
import subscriptionSlice from "../store/Admin/SubscriptionManagement/SubscriptionManagement"
import bookingHistoryReducer from "./BookingHistory/BookingHistorySlice"
import manualQuoteSlice  from "../store/ManualQuote/ManualQuoteSlice"
import rate_managementSlice from "./Admin/RateManagement/RateManagementSlice"
import newsearchformSlice from "./Newsearchform/Newsearchform"
import newqueriesSlice from "./Newsearchform/Newqueries"
import branchReducer from "./Newslices/branchSlice"
import Querybookingid from "./Querybookingid/Querybookingidslice"
export const store = configureStore({
    reducer:{
        userlogin : AuthSlice,
        signup: SignupSlice,
        commonapi: CommonSlice,
        usersection: KycSlice,
        searchrates: SearchRatesSlice,
        queriessate : QueriesSlice,
        bookinghistory : BookingHistorySlice,
        userprofile : ProfileSlice,
        offlinepayment : OfflinePaymentSlice,
        creditlimit : CreditLimitSlice,
        packaging: sharedStateReducer,
        classDescription: set_selectedOption,
        lclpackaging: setlclpackagedata,
        //role: setRole
        data: dataReducer,
        roles: rolesReducer,
        userAirlineLogin : loginAirlineSlice,
        customerAdmin:customeradmin,
        organization: organizationReducer,// organization create page open slice
        markup:markupSlice,
        vehicletype:Vehicletypeslice,
        airport: airportReducer,
        contact:contactSlice,
        subscription : subscriptionSlice,
        bookingHistory: bookingHistoryReducer,
        manualQuoteSlice,
        ratemanagement: rate_managementSlice,
        newsearchform: newsearchformSlice,
        newqueries:newqueriesSlice,
        branch: branchReducer,
         querybookingid: Querybookingid
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    })    
})